import { Component, OnDestroy, OnInit } from '@angular/core';
import { ResourceService } from 'src/app/services/resource.service';
import Resource from 'src/app/interfaces/Resource';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import { ForumService } from 'src/app/services/forum.service';
import Discussion from 'src/app/interfaces/Discussion';
import { AnalyticsService } from 'src/app/services/analytics.service';

@Component({
  selector: 'app-resource-single',
  templateUrl: './resource-single.component.html',
  styleUrls: ['./resource-single.component.scss'],
})
export class ResourceSingleComponent implements OnInit, OnDestroy {
  resource$;
  resource: Resource;
  subscriptions: Subscription = new Subscription();
  currentUser;
  discussions;
  userHasDiscussed = false;
  resourceImg;

  constructor(
    private resourceService: ResourceService,
    private route: ActivatedRoute,
    private userService: UserService,
    private forumService: ForumService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    this.analyticsService.event('resource_entry_view');
    this.resource$ = this.route.paramMap.pipe(
      switchMap((params: ParamMap) => this.resourceService.getResource(params.get('id')))
    );
    this.resource$.subscribe((r) => {
      this.resource = r;
      this.setResourceImg();
      this.forumService.getResourceDiscussions(this.resource.id).subscribe(
        (d) => {
          this.discussions = d;
          this.userHasDiscussed = this.discussions.some((el) => el.owner === this.currentUser.uid);
        },
        (e) => console.error(e)
      );
    });

    this.subscriptions.add(
      this.userService.user.subscribe((u) => {
        if (u && u.uid) {
          this.currentUser = u;
        }
      })
    );
  }

  cardEvent(e, comment, expand = null) {
    if (e.type === 'update_resource') {
      this.resourceService.updateResource(e.id, e.update);
    }
  }

  setResourceImg() {
    if (this.resource.resourceMeta) {
      if (this.resource.resourceMeta.image.charAt(0) === '/') {
        const url = new URL(this.resource.resourceUrl).origin;
        this.resourceImg = url + this.resource.resourceMeta.image;
      } else {
        this.resourceImg = this.resource.resourceMeta.image;
      }
    }
  }

  trackEvent(name: string): void {
    this.analyticsService.event(name);
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
